import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useGlobalStore, useInstallationStore } from "src/store";
import {
  FALLBACK_BASE_PRICE,
  FALLBACK_OUTSIDE_LIFT_PRICE,
  FALLBACK_PERMISSION_PRICE,
} from "src/utils/constants";
import { FormSchema } from "src/utils/formSchema";
import { AnimatedSelect } from "../AnimatedSelect/AnimatedSelect";
import { FormControl, FormField, FormItem, FormMessage } from "../ui/form";

type Props = {
  form: UseFormReturn<FormSchema, unknown>;
};

export default function CitySelector({ form }: Props) {
  const { t } = useTranslation();
  const { global, setBasePrice, setPermissionPrice, setWithOutsideLiftPrice } =
    useGlobalStore();
  const {
    installationDetails,
    setInstallationDetails,
    resetInstallationDetails,
  } = useInstallationStore();

  return (
    <div>
      <FormField
        control={form.control}
        name="city"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <AnimatedSelect
                options={global.cities}
                isLoading={!global.cities || !global.cities.length}
                defaultValue={global.cities.filter(
                  (city) => city.value === installationDetails.city?.id
                )}
                value={
                  installationDetails.city
                    ? {
                        value: installationDetails.city.id,
                        label: installationDetails.city.label,
                      }
                    : undefined
                }
                placeholder={t("installations:inputs:city:placeholder")}
                onChange={(e: any) => {
                  resetInstallationDetails();
                  if (e) {
                    const selectedCity = global.cities.find(
                      (city) => city.value === e.value
                    )!;
                    const formatedCity = {
                      value: selectedCity.value,
                      label: selectedCity.label,
                      basePrice: selectedCity.basePrice,
                      withOutsideLiftPrice: selectedCity.withOutsideLiftPrice,
                      id: selectedCity.value,
                    };

                    setBasePrice(selectedCity.basePrice || FALLBACK_BASE_PRICE);
                    setPermissionPrice(
                      selectedCity.permissionPrice || FALLBACK_PERMISSION_PRICE
                    );
                    setWithOutsideLiftPrice(
                      selectedCity.withOutsideLiftPrice ||
                        FALLBACK_OUTSIDE_LIFT_PRICE
                    );
                    setInstallationDetails({ city: formatedCity });
                    return field.onChange(e.value);
                  }
                }}
                classNamePrefix="select"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
